export default __webpack_public_path__ + "static/media/ic_czech_republic.aee4a991.svg";